import {iomoLayouts as layouts} from '../../layouts/iomoLayouts';
import {iomoMaterials} from '../../iomoMaterial';

export const splashConfigurations = [
	{
		layoutType: 'spiral',
		bracket: '195',
		opticalSystem: 'Comfort',
		cap: 'short',
		modifier: 'none',
		housingSize: '195',
		reflectorColour: 'silver',
		materialPole: iomoMaterials.graphite.material,
		materialBody: iomoMaterials.graphite.material,
		materialRing: iomoMaterials.graphite.material,
	},
	{
		layoutType: 'spiral',
		bracket: '250',
		opticalSystem: 'Performance',
		cap: 'asymetric',
		modifier: 'none',
		housingSize: '250',
		reflectorColour: 'gold',
		materialPole: iomoMaterials.blackGloss.material,
		materialBody: iomoMaterials.blackGloss.material,
		materialRing: iomoMaterials.blackGloss.material,
	},
];


const splashConfigValues = {
	design: 'pole',
	poleHeight: 9,
	poleDiameter: 140,
	poleShape: 'cylindrical',
	numberOfHeads: 8,
	layoutType: 'spiral',
	environment: 'day',
	heightMax: 9,
	heightMin: 5,
	angleMax: 360,
	angleMin: 0,
	heads: [],
	selectedHead: null,

	bracket: '195',
	opticalSystem: 'Comfort',
	colourTemperature: '3000K',
	lightDistribution: '30',
	reflectorColour: 'gold',
	cap: 'short',
	modifier: 'none',
	housingSize: '195',
	color: '#666',
	materialPole: iomoMaterials.graphite.material,
	materialBody: iomoMaterials.graphite.material,
	materialRing: iomoMaterials.graphite.material,
};

const layout = layouts.spiral.calculate('pole', splashConfigValues);
const branches = layout.branches;
for (let i = 0; i < 8; i++) {
	const head = {
		active: i < branches.length,
		type: 'luminaire',
		design: 'pole',
		housingSize: '195',
		opticalSystem: 'Comfort',
		cap: 'short',
		modifier: 'none',
		height: i < branches.length ? branches[i].height : 0,
		angle: i < branches.length ? branches[i].angle : 0,
		roll: 0,
		dimmingLevel: null,
		colourTemperature: '3000K',
		environment: 'day',
		lightDistribution: '30',
		reflectorColour: 'gold',
		accessories: 'None',
		spcDecisions: null,
		collisions: [],
		materialPole: iomoMaterials.graphite.material,
		materialBody: iomoMaterials.graphite.material,
		materialRing: iomoMaterials.graphite.material,
	};
	splashConfigValues.heads.push(head);
}

export function getSplashConfig(index) {
	const config = JSON.parse(JSON.stringify(splashConfigValues));
	const lay = layouts.spiral.calculate('pole', splashConfigValues);
	const bran = lay.branches;
	config.opticalSystem = splashConfigurations[index].opticalSystem;
	config.cap = splashConfigurations[index].cap;
	config.housingSize = splashConfigurations[index].housingSize;
	config.reflectorColour = splashConfigurations[index].reflectorColour;
	config.materialPole = splashConfigurations[index].materialPole;
	config.materialBody = splashConfigurations[index].materialBody;
	config.materialRing = splashConfigurations[index].materialRing;
	const heads = [];
	splashConfigValues.heads.forEach((h, i) => {
		const head = JSON.parse(JSON.stringify(h));
		head.active = i < bran.length;
		head.height = i < bran.length ? bran[i].height : 0;
		head.angle = i < bran.length ? bran[i].angle : 0;

		head.opticalSystem = config.opticalSystem;
		head.cap = config.cap;
		head.housingSize = config.housingSize;
		head.reflectorColour = config.reflectorColour;
		head.materialPole = config.materialPole;
		head.materialBody = config.materialBody;
		head.materialRing = config.materialRing;
		heads.push(head);
	});
	config.heads = heads;

	return config;
}

export {splashConfigValues};
